import styled from '@emotion/styled'
import { ApiLandingPageVideo, ApiVideo } from '@storefronts/common-types'
import React, { useContext, useEffect, useState } from 'react'
import { MEDIA_BORDER_RADIUS_VAR } from '../../../../context/CustomizationContextProvider'
import { FullScreenVideoContext } from '../../../../context/fullScreenVideoContext'
import { getAnimatedUrl } from '../../../../utils/getAnimatedUrl'
import { getVideoPosterUrl } from '../../../../utils/helpers'
import { AnimatedThumbnail } from './AnimatedThumbnail'
import {
    PlayButtonOverlay,
    VideoIsPlayingOverlay,
} from './CarouselSlideOverlays'

type SlideContentProps = {
    v: ApiLandingPageVideo | ApiVideo
    idx: number
    slideWidth: number
    isActive: boolean
    shouldPreload?: boolean
    priority?: boolean
    onSlideClick: (idx: number) => void
}

const SlideContainer = styled.div({
    position: 'relative',
    borderRadius: `var(${MEDIA_BORDER_RADIUS_VAR})`,
    zIndex: 1,
    overflow: 'hidden',
})

const SlideContentInner: React.FC<SlideContentProps> = ({
    v,
    idx,
    slideWidth,
    isActive,
    shouldPreload = false,
    priority = false,
    onSlideClick,
}) => {
    const { currentPlaylist, currentIdx } = useContext(FullScreenVideoContext)
    const [isPlaying, setIsPlaying] = useState(false)

    const onClick = () => {
        onSlideClick(idx)
    }

    useEffect(() => {
        if (
            !currentPlaylist ||
            currentIdx < 0 ||
            currentIdx > currentPlaylist.videos.length - 1
        ) {
            setIsPlaying(false)
            return
        }
        const fullScreenVideo = currentPlaylist.videos[currentIdx]
        setIsPlaying(fullScreenVideo.videoHash === v.videoHash)
    }, [v, currentIdx, currentPlaylist])

    return (
        <SlideContainer
            style={{
                width: `${slideWidth}px`,
                height: `${(16 / 9) * slideWidth}px`,
            }}
        >
            {!isPlaying && <PlayButtonOverlay />}

            {isPlaying && <VideoIsPlayingOverlay />}

            <AnimatedThumbnail
                animated={isActive && !isPlaying}
                animatedUrl={getAnimatedUrl(v, true) ?? ''}
                staticUrl={getVideoPosterUrl(v)}
                video={v}
                onClick={onClick}
                priority={priority}
                shouldPreload={shouldPreload}
            />
        </SlideContainer>
    )
}

export const SlideContent = React.memo(SlideContentInner)
